export enum ELegalDocumentsRoute {
  DOCUMENT_VERSION = '/legal-documents/:documentId/:versionId',
  WORKING_CONDDITIONS = '/working-conditions',
}
